import Tips, { Tip } from './Tips'

export { Tip }
export default Tips
